// extracted by mini-css-extract-plugin
export default {"smoothly_appear":"debt-pay-button_smoothly_appear__n2YRR","smoothly-appear":"debt-pay-button_smoothly-appear__dVUbi"};